import React, { Component } from 'react'
import PubNubReact from 'pubnub-react'

class PubnubController extends Component {
  constructor(props) {
    super(props)
    this.pubnub = new PubNubReact({
      publishKey: process.env.REACT_APP_PUBNUB_PUBLISH_KEY,
      subscribeKey: process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY,
      uuid: this.props.uuid,
      heartbeatInterval: 120,
      presenceTimeout: 120,
      ssl: true,
      state: this.props.state
    })
    this.pubnub.init(this)
  }

  componentWillMount() {
    this.pubnub.subscribe({
      channels: [this.props.channelName],
      withPresence:
        this.props.withPresence === undefined ? false : this.props.withPresence
    })

    this.pubnub.getMessage(this.props.channelName, msg => {
      if (this.props.hasOwnProperty('onMessage')) {
        this.props.onMessage(msg.message)
      }
    })

    this.pubnub.getStatus(st => {
      if (this.props.hasOwnProperty('onStatus')) {
        this.props.onStatus(st)
      }
    })

    this.pubnub.getPresence(this.props.channelName, msg => {
      if (this.props.hasOwnProperty('onPresence')) {
        this.props.onPresence(msg)
      }
    })
  }

  componentWillUnmount() {
    this.pubnub.unsubscribe({
      channels: [this.props.channelName]
    })
  }

  publish(message) {
    const { channelName: channel } = this.props
    this.pubnub.publish({
      message,
      channel
    })
  }

  setUUID(num) {
    this.pubnub.setUUID(num)
  }

  render() {
    return null
  }
}
export default PubnubController



// WEBPACK FOOTER //
// ./src/components/PubnubController/index.jsx